import React from 'react'
import './Skills.css'

const Skills = () => {
  return (
    <section id='skills'>
        <div className='container'>
            <div className='titel'>
                <h2>My Skills</h2>
                <h3>My Skills</h3>
            </div>
            <div className='skills-wrapper'>
                <div className='skills-card'>
                    <div className='skills-card-head'>
                        <img src='./assets/web design.svg' alt='' />
                        <h3>Web Design</h3>
                    </div>
                    <p>
                        If you look for a unique and high quality UI UX design you are in the right place.
                    </p>
                </div>
                <div className='skills-card'>
                    <div className='skills-card-head'>
                        <img src='./assets/web development.svg' alt='' />
                        <h3>Development</h3>
                    </div>
                    <p>
                        Your website will be developed professionally to be fast and responsive.
                    </p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Skills